import React from 'react';

const Payment = () => {
    return (
        <div>
            <h2 className="text-center">Payment system coming soon.</h2>
        </div>
    );
};

export default Payment;